import moment from 'moment';

export const calculateTimeLeft = (expirationEpoch: number) => {
  const difference = expirationEpoch - Math.round(Date.now() / 1000);

  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, difference };
  }

  const duration = moment.duration(difference, 'seconds');
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return { days, hours, minutes, seconds, difference };
};
